package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import app.cash.sqldelight.coroutines.mapToOneOrNull
import com.tedd.db.Category
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class CategoryRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Category>> =
        db.categoryQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeById(id: String): Flow<Category?> =
        db.categoryQueries.selectById(id).asFlow().mapToOneOrNull(Dispatchers.Default)

    suspend fun create(
        name: String,
        color: String,
        icon: String,
        orderIndex: Long = 0,
        id: String = newId("cat"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.categoryQueries.insert(id, name, color, icon, orderIndex, now, now)
        id
    }

    suspend fun update(
        id: String,
        name: String,
        color: String,
        icon: String,
        orderIndex: Long,
    ) = withContext(Dispatchers.Default) {
        db.categoryQueries.update(name, color, icon, orderIndex, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.categoryQueries.softDelete(now, now, id)
    }

    suspend fun restore(id: String) = withContext(Dispatchers.Default) {
        db.categoryQueries.restore(nowMillis(), id)
    }
}